import type { APIDispatch } from '@/hooks/api';
import type {
  CreateUserResponse,
  LoadUsersResponse,
  PartialUser,
  User,
} from './types';
import type { AuthContext } from '@/context';
import type { UsersStore } from '.';
import { apiInvoke, shouldLoad } from '../helpers/load';
import { makePayloadRequestInit } from '@/lib/api';

export async function loadUsers(
  { loaded, dispatch }: UsersStore,
  { force, api, auth }: { force: boolean; api: APIDispatch; auth: AuthContext },
) {
  if (!shouldLoad(loaded.current, force, auth)) {
    return false;
  }

  loaded.current = true;
  const res = await apiInvoke<LoadUsersResponse>(api, '/user', auth);
  dispatch({ type: 'setUsers', users: res });

  return true;
}

export async function updateUser(
  { dispatch }: UsersStore,
  {
    api,
    auth,
    item,
  }: { api: APIDispatch; auth: AuthContext; item: PartialUser },
): Promise<boolean> {
  await apiInvoke(
    api,
    `/user/${item.id}`,
    auth,
    makePayloadRequestInit(item.data, 'PATCH'),
  );
  dispatch({ type: 'updateUser', user: item });

  return true;
}

export async function archiveUser(
  store: UsersStore,
  {
    api,
    auth,
    item,
  }: { api: APIDispatch; auth: AuthContext; item: PartialUser },
) {
  await updateUser(store, {
    api,
    auth,
    item: { id: item.id, data: { archived: true } },
  });
}

export async function createUser(
  { dispatch }: UsersStore,
  {
    api,
    auth,
    item,
    invite,
  }: { api: APIDispatch; auth: AuthContext; item: User; invite: boolean },
) {
  let path = `/user`;
  if (!invite) {
    path = `${path}?invite=false`;
  }

  const res = await apiInvoke<CreateUserResponse>(
    api,
    path,
    auth,
    makePayloadRequestInit(item.data, 'POST'),
  );
  dispatch({ type: 'addUser', user: res });
}

export async function resendInvite({
  api,
  auth,
  item,
}: {
  api: APIDispatch;
  auth: AuthContext;
  item: User;
}) {
  await apiInvoke(
    api,
    `/user/${item.id}`,
    auth,
    makePayloadRequestInit({ app: 'mhai' }, 'PUT'),
  );
}
